export default "/assets/da462680f654da69.png"